import React from 'react';
import { formatMoney } from '../../../../utils/utils';
import { momentParseDate } from '../../../../helpers';
import { Link } from 'react-router-dom';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { TransportOrderFilters } from '../../../../app/models/TransportOrder';

type Props = {
    data: any[];
    progressPending?: boolean;
    totalRows: number;
    filter: TransportOrderFilters;
    setFilter: (filter: TransportOrderFilters) => void;
};

const CommissionsDataTable = ({ 
    data, 
    progressPending, 
    totalRows,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'Orden de Transporte',
            selector: (row: any) => row.id,
            sortable: false,
            sortField: 'motivo',
            cell: (row: any, index: any, column: any) => (                                   
                <span className="">
                    <Link to={`/transport-orders/${row.id}/edit`}>
                        #{row.id}
                    </Link>
                </span>
            )
        },
        {
            name: 'Conductor',
            selector: (row: any) => row.worker,
            sortable: false,
            sortField: 'Conductor',
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.worker.user.name}</span>
            )
        },
        {
            name: 'Comisión',
            selector: (row: any) => row.bank,
            sortable: false,
            sortField: 'banco',
            cell: (row: any, index: any, column: any) => (
                <span className="">{formatMoney(row.commission)}</span>
            )
        },
        {
            name: 'Fecha de Programa',
            selector: (row: any) => row?.program_date,
            sortable: false,
            sortField: 'program_date',
            minWidth: '120px',
            cell: (row: any, index: any, column: any) => (
                <span className="">
                    {momentParseDate(row.program_date)}
                </span>
            )
        },

    ]
    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={data}
                progressPending={progressPending} 
                paginationTotalRows={totalRows}                
                filter={filter} 
                setFilter={setFilter}         
                isMobileStacked={true}   
            />
        </div>
    )
}

export default CommissionsDataTable
